import { IAuthorizationLineWithRefunded, IFlagShowCardInfo, ITransactionDetails } from 'features/transactions/types';
import {
	IAuthorizationFullDetailItem,
	IAuthorizationWithCrosses,
	ICrossWithServiceInfo,
	ITransactionFinalization,
	ITransactionFullDetailApiResponse,
} from './types';
import { resolveCarrierCodeFromOptionName } from './helpers/resolveCarrierCode';

const mapAuthorizationItem = (item: IAuthorizationFullDetailItem): IAuthorizationWithCrosses => {
	const { authorizationData, refunded, crossesData } = item;

	const chargedAgainstOptionCode =
		authorizationData.chargedAgainstOptionCode ??
		resolveCarrierCodeFromOptionName(authorizationData.chargedAgainstOptionName) ??
		undefined;

	const authorization: IAuthorizationWithCrosses = {
		id: authorizationData.id,
		chargedAgainstOptionName: authorizationData.chargedAgainstOptionName,
		chargedAgainstOptionCode,
		chargedAgainstOptionType: authorizationData.chargedAgainstOptionType,
		initialAmountAuthorized: authorizationData.initialAmountAuthorized,
		amountAuthorized: authorizationData.amountAuthorized,
		coinCode: authorizationData.coinCode,
		authorizationCode: authorizationData.authorizationCode,
		paymentDate: authorizationData.paymentDate,
		paymentDueDate: authorizationData.paymentDueDate,
		pendingToCross: String(authorizationData.pendingToCross),
		state: authorizationData.state,
		createdAt: authorizationData.createdAt,
		createdBy: authorizationData.createdBy,
		refunded,
		crossesData: crossesData as ICrossWithServiceInfo[],
	};

	return authorization;
};

export const mapTransactionFullDetailResponse = (
	response: ITransactionFullDetailApiResponse,
): {
	transaction: ITransactionDetails;
	authorizations: IAuthorizationWithCrosses[];
	finalizationsData: ITransactionFinalization[];
} => {
	const authorizations = response.authorizationsData.map(mapAuthorizationItem);

	const transaction: ITransactionDetails = {
		transactionData: response.transactionData,
		authorizationsData: authorizations as IAuthorizationLineWithRefunded[],
		flagShowCardInfo: response.flagShowCardInfo,
	};

	return {
		transaction,
		authorizations,
		finalizationsData: response.finalizationsData ?? [],
	};
};

export const canShowCardSensitiveInfo = (flagShowCardInfo: IFlagShowCardInfo): boolean =>
	flagShowCardInfo.showCreditCardNumber || flagShowCardInfo.showSecurityCode;
